/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import Tbl from '@appblocks/codegeneration/Libraries/Tbl';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    if (!feature.getEnabled()) {
        return blocks;
    }

    const TBL_DEBUG_PRINT = feature.getSettingValue('TBL_DEBUG_PRINT');
    const TABLES = feature.getSettingValue('TABLES');

    const tablesDefined = feature.getSettingValue('TABLES');

    const TBL_MAX_NUM_TABLES = TABLES.length;

    if (TBL_MAX_NUM_TABLES > 0) {
    //         blocks.push({
    //             location: 'boot',
    //             blockType: BlockType.CODE,
    //             template: `
    // 'Tables setup
    // '================================================================
    // if tbl_start()<>EN_TBL_STATUS_OK then
    //     callback_system_error("TBL", "Failed to start")
    //     sys.halt()
    // end if
    // '-----------------------------------------------------------------`,
    //         });

        //         if (feature.getSettingValue('WEBENABLED') === '1') {
        //             let initCode = '';
        //             for (let i = 0; i < tablesDefined.length; i += 1) {
        //                 const tableName = tablesDefined[i].getSettingValue('NAME');
        //                 initCode += `tbl_web_set("${tableName}",true)\r\n`;
        //             }

        //             blocks.push({
        //                 location: 'boot',
        //                 blockType: BlockType.CODE,
        //                 template: `
        // tbl_web_start()
        // dim schema_changed as boolean = false
        // ${initCode}


        // if tbl_schema_check(TBL_DESCRIPTOR_FILE)<>EN_TBL_STATUS_OK then
        //     schema_changed = YES
        // end if

    // if schema_changed= YES then
    //     callback_system_error("TBL", "Schema changed, formatting flash")
    //     if fd.formatj(fd.availableflashspace/4*3,32,100)<>PL_FD_STATUS_OK then
    //         callback_system_error("TBL", "Failed to format flash")
    //         sys.halt()
    //     end if
    //     if tbl_start()<>EN_TBL_STATUS_OK then
    //         callback_system_error("TBL", "Failed to start")
    //         sys.halt()
    //     end if
    //     if tbl_schema_check(TBL_DESCRIPTOR_FILE)<>EN_TBL_STATUS_OK then
    //         callback_system_error("TBL", "Failed to check schema")
    //         sys.halt()
    //     end if
    // end if`,
    //             });
    //         }
    }

    const tablesJson = [];

    for (let i = 0; i < TABLES.length; i += 1) {
        const TABLE = TABLES[i];
        const tableJson = Tbl.getTableJson(TABLE);
        tablesJson.push(tableJson);
    }

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.LOCATION,
        template: `
const tablesSchema = {
    /****TABLES_SCHEMA****/
}
`,
    });

    for (let i = 0; i < tablesJson.length; i += 1) {
        blocks.push({
            location: 'TABLES_SCHEMA',
            blockType: BlockType.CODE,
            template: `
${tablesJson[i].name} : ${JSON.stringify(tablesJson[i])},
`,
        });
    }

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
tbl_start()
`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function tbl_start() {
    let init = false;
    const tablesInSchema = Object.keys(tablesSchema);
    const tablesInSimulator = Object.keys(simulator.tables);
    // Sort both arrays for comparison
    tablesInSchema.sort();
    tablesInSimulator.sort();


    // Check if arrays are different
    if (JSON.stringify(tablesInSchema) !== JSON.stringify(tablesInSimulator)) {
        init = true;
    }
    if (tablesInSimulator.length !== tablesInSchema.length) {
        init = true;
    }
    
    const newHashes = {};
    for (let i = 0; i < tablesInSchema.length; i += 1) {
        const table = tablesInSchema[i];
        const schema = tablesSchema[table];
        let hash = '';
        for (let j = 0; j < schema.fields.length; j += 1) {
            hash += schema.fields[j].fieldType + schema.fields[j].p1 + schema.fields[j].p2;
        }
        hash = hash_string(hash);
        if (
            !simulator.tablesHashes
            || !simulator.tablesHashes[table]
            || !simulator.tables
            || !simulator.tables[table]
            || simulator.tablesHashes[table] && simulator.tablesHashes[table] !== hash) {
            console.log("The tables schema has changed. Restoring default values...");
            init = true;
        }
        newHashes[table] = hash;
    }
    simulator.emit({
        eventType: 'tbl_hashes',
        hashes: newHashes,
    });
    if (init) {
        tbl_format();
    }
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function hash_string(message) {
    // Simple non-cryptographic hash function for synchronous operation
    let hash = 0;
    for (let i = 0; i < message.length; i++) {
        const char = message.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash |= 0; // Convert to 32bit integer
    }
    // Convert to hex string
    let hashHex = (hash >>> 0).toString(16);
    // Pad to ensure consistent length
    while (hashHex.length < 8) {
        hashHex = '0' + hashHex;
    }
    return hashHex;
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function tbl_format() {
    const tablesInSchema = Object.keys(tablesSchema);
    const newTables = {};
    for (const table of tablesInSchema) {
        newTables[table] = [];
    }
    simulator.tables = newTables;
    simulator.emit({
        eventType: 'tbl_update',
        tables: newTables,
    });
}`,
    });


    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function tbl_web_add_row(tableName, row) {
    const tablesInSchema = Object.keys(tablesSchema);
    for (let i = 0; i < tablesInSchema.length; i += 1) {
        const table = tablesInSchema[i];
        if (table !== tableName) {
            continue;
        }
        const schema = tablesSchema[table];
        const fields = schema.fields;
        const fieldValues = [];
        if (fields.length === 0 || fields.length !== row.length) {
            throw new Error('Invalid row');
            console.log('Invalid row');
            return;
        }
        for (let j = 0; j < fields.length; j += 1) {
            const field = fields[j];
            let newValue = row[j];
            if (newValue === '') {
                newValue = field.fieldDefault;
            }
            if (field.fieldType === 'S') {
                if (newValue.length > field.p2) {
                    console.log('Invalid value');
                    return;
                }
                if (newValue.length < field.p1) {
                    console.log('Invalid value');
                    return;
                }
            } else if (field.fieldType === 'F') {
                newValue = Number(newValue);
                if (Number.isNaN(newValue)) {
                    console.log('Invalid value');
                    return;
                }
                if (newValue < field.p1) {
                    console.log('Invalid value');
                    return;
                }
                if (newValue > field.p2) {
                    console.log('Invalid value');
                    return;
                }
            } else if (field.fieldType === 'T') {
                newValue = Number(newValue);
                if (Number.isNaN(newValue)) {
                    console.log('Invalid value');
                    return;
                }
                if (newValue < 0 || newValue > 2147483647) {
                    console.log('Invalid value');
                    return;
                }
            } else if (field.fieldType === 'M') {
                newValue = Number(newValue);
                if (Number.isNaN(newValue)) {
                    console.log('Invalid value');
                    return;
                }
                if (newValue < 0 || newValue > 86400) {
                    console.log('Invalid value');
                    return;
                }
            }
            fieldValues.push(newValue);
        }
        simulator.tables[tableName].push(fieldValues);
        simulator.emit({
            eventType: 'tbl_update',
            tables: simulator.tables,
        });
        callback_tbl_modified();
    }
}

function tbl_web_delete_row(tableName, rowIndex) {
    simulator.tables[tableName].splice(rowIndex, 1);
    simulator.emit({
        eventType: 'tbl_update',
        tables: simulator.tables,
    });
}

function tbl_web_edit_row(tableName, rowIndex, row) {
    simulator.tables[tableName][rowIndex] = row;
    simulator.emit({
        eventType: 'tbl_update',
        tables: simulator.tables,
    });
}

function tbl_web_clear_table(tableName) {
    simulator.tables[tableName] = [];
    simulator.emit({
        eventType: 'tbl_update',
        tables: simulator.tables,
    });
}

        `,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        id: 'tbl_record_find_sorted',
        template: `
function tbl_record_find_sorted(table_name,search_data,field_name,table_find_result_index,wraparound,find_method) {
try {
    const tableCopy = [...simulator.tables[table_name]];
    const fieldIndex = tablesSchema[table_name].fields.findIndex(field => field.name === field_name);
    
    // Add original indices to each row for tracking after sort
    const indexedTableCopy = tableCopy.map((row, index) => [index, ...row]);
    
    // Start search from the provided index
    const startIndex = Math.max(0, table_find_result_index);
    const searchableRows = indexedTableCopy.slice(startIndex);
    
    // Sort the table based on the find method
    searchableRows.sort((a, b) => {
        const aValue = a[fieldIndex + 1]; // +1 because we added the index
        const bValue = b[fieldIndex + 1];
        
        // Different sorting strategies based on find method
        switch (find_method) {
            case 'PL_FD_FIND_NOT_EQUAL':
                return 0; // No need to sort for NOT_EQUAL
            case 'PL_FD_FIND_LESSER':
            case 'PL_FD_FIND_LESSER_EQUAL':
                // Descending order for LESSER operations
                return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
            case 'PL_FD_FIND_EQUAL':
            case 'PL_FD_FIND_GREATER':
            case 'PL_FD_FIND_GREATER_EQUAL':
            default:
                // Ascending order for EQUAL, GREATER, GREATER_EQUAL
                return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
        }
    });
    
    
    // Find the first matching row according to the find method
    for (let i = 0; i < searchableRows.length; i += 1) {
        const row = searchableRows[i];
        const value = row[fieldIndex + 1];

        switch (find_method) {
            case 'PL_FD_FIND_NOT_EQUAL':
                if (value !== search_data) {
                    return row[0]; // Return original index
                }
                break;
            case 'PL_FD_FIND_EQUAL':
                if (value === search_data) {
                    return row[0];
                }
                break;
            case 'PL_FD_FIND_GREATER':
                if (value > search_data) {
                    return row[0];
                }
                break;
            case 'PL_FD_FIND_LESSER':
                if (value < search_data) {
                    return row[0];
                }
                break;
            case 'PL_FD_FIND_GREATER_EQUAL':
                if (value >= search_data) {
                    return row[0];
                }
                break;
            case 'PL_FD_FIND_LESSER_EQUAL':
                if (value <= search_data) {
                    return row[0];
                }
                break;
        }
    }
    
    // If no match found and wraparound is true, start from beginning
    if (wraparound && startIndex > 0) {
        const initialRows = indexedTableCopy.slice(0, startIndex);
        
        // Apply the same sorting to the initial portion
        initialRows.sort((a, b) => {
            const aValue = a[fieldIndex + 1];
            const bValue = b[fieldIndex + 1];
            
            switch (find_method) {
                case 'PL_FD_FIND_NOT_EQUAL':
                    return 0;
                case 'PL_FD_FIND_LESSER':
                case 'PL_FD_FIND_LESSER_EQUAL':
                    return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
                default:
                    return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
            }
        });
        
        // Search the initial portion
        for (let i = 0; i < initialRows.length; i += 1) {
            const row = initialRows[i];
            const value = row[fieldIndex + 1];
            
            switch (find_method) {
                case 'PL_FD_FIND_NOT_EQUAL':
                    if (value !== search_data) {
                        return row[0];
                    }
                    break;
                case 'PL_FD_FIND_EQUAL':
                    if (value === search_data) {
                        return row[0];
                    }
                    break;
                case 'PL_FD_FIND_GREATER':
                    if (value > search_data) {
                        return row[0];
                    }
                    break;
                case 'PL_FD_FIND_LESSER':
                    if (value < search_data) {
                        return row[0];
                    }
                    break;
                case 'PL_FD_FIND_GREATER_EQUAL':
                    if (value >= search_data) {
                        return row[0];
                    }
                    break;
                case 'PL_FD_FIND_LESSER_EQUAL':
                    if (value <= search_data) {
                        return row[0];
                    }
                    break;
            }
        }
        
        return -1; // No match found even with wraparound
    } else if (wraparound) {
        return 0; // If startIndex is 0 and wraparound is true
    } else {
        return -1; // No match found and no wraparound
    }
} catch (error) {
    throw new Error(\`tbl_record_find_sorted: \${error}\`);
}
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        id: 'getTableRow',
        blockType: BlockType.CODE,
        template: `
function getTableRow(table_name,row_index) {
    if (row_index < 0 || row_index >= simulator.tables[table_name].length) {
        throw new Error('Invalid row index');
    }
    return simulator.tables[table_name][row_index];
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
function callback_tbl_modified(table_name,modified_operation) {
    /****callback_tbl_modified****/
}`,
    });

    return blocks;
};
